/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { Booking } from './booking';

export type GenericApiResponseBookingData = Booking | null;
